import { validatePaymentRequest } from "./ApplePayPaymentRequest";
import { isIso4217, isLocaleValid, isString, isNumeric } from "@payair/e-com-common-sdk/core/Validators";
/**
 * Payair Apple Pay transaction options type.
 */
var ApplePayInitParams = /** @class */ (function () {
    function ApplePayInitParams() {
    }
    return ApplePayInitParams;
}());
export { ApplePayInitParams };
/** @internal */
export var validateApplePayInitParams = function (applePayInitParams) {
    var errorMessage = [];
    if (!applePayInitParams) {
        errorMessage.push("applePayInitParams not defined");
        return errorMessage;
    }
    // totalAmountLabel validation
    if (!applePayInitParams.totalAmountLabel) {
        errorMessage.push("totalAmountLabel not defined");
    }
    else if (!isString(applePayInitParams.totalAmountLabel)) {
        errorMessage.push("totalAmountLabel is not a string");
    }
    // totalAmount validation
    if (!applePayInitParams.totalAmount) {
        errorMessage.push("totalAmount not defined");
    }
    else if (!isNumeric(applePayInitParams.totalAmount) ||
        parseFloat(applePayInitParams.totalAmount) <= 0 ||
        !new RegExp("^[0-9]+(\\.[0-9][0-9])$").test(applePayInitParams.totalAmount))
        errorMessage.push("amount is not a valid number: ".concat(applePayInitParams.totalAmount));
    // locale validation
    if (!applePayInitParams.locale) {
        errorMessage.push("locale is not defined");
    }
    else if (!isLocaleValid(applePayInitParams.locale)) {
        errorMessage.push("locale is not valid");
    }
    // currencyCode validation
    if (!applePayInitParams.currencyCode) {
        errorMessage.push("currencyCode is not defined");
    }
    else if (!isIso4217(applePayInitParams.currencyCode)) {
        errorMessage.push("currencyCode is not valid");
    }
    // merchantId validation
    if (!applePayInitParams.merchantId) {
        errorMessage.push("merchantId not defined");
    }
    else if (!isString(applePayInitParams.merchantId)) {
        errorMessage.push("merchantId is not a string");
    }
    // merchantName validation
    if (!applePayInitParams.merchantName) {
        errorMessage.push("merchantName not defined");
    }
    else if (!isString(applePayInitParams.merchantName)) {
        errorMessage.push("merchantName is not a string");
    }
    // pspName validation
    if (!applePayInitParams.pspName) {
        errorMessage.push("pspName not defined");
    }
    else if (!isString(applePayInitParams.pspName)) {
        errorMessage.push("pspName is not a string");
    }
    // transactionId validation
    if (!applePayInitParams.transactionId) {
        errorMessage.push("transactionId not defined");
    }
    else if (!isString(applePayInitParams.transactionId)) {
        errorMessage.push("transactionId is not a string");
    }
    // applePayPaymentRequest validation
    if (applePayInitParams.applePayPaymentRequest) {
        var paymentRequestValidationResult = validatePaymentRequest(applePayInitParams.applePayPaymentRequest);
        errorMessage = errorMessage.concat(paymentRequestValidationResult);
    }
    return errorMessage;
};
